import { postAES } from "@/api/request"

export const getMeeting = params => postAES("/v3/organ/info", params)//机构详情
export const getMeetList = params => postAES("/v3/organ/session", params)//机构专场列表